import { render, staticRenderFns } from "./DisposalOrdersEditBlock.vue?vue&type=template&id=51cfe15c"
import script from "./DisposalOrdersEditBlock.vue?vue&type=script&lang=js"
export * from "./DisposalOrdersEditBlock.vue?vue&type=script&lang=js"
import style0 from "./DisposalOrdersEditBlock.vue?vue&type=style&index=0&id=51cfe15c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports